import { combineEpics } from 'redux-observable'
import { ListOrganizationsEpic } from './ListOrganizations/ListOrganizationsEpic.js'
import { GetOrganizationMembersEpic } from './GetOrganizationMembers/GetOrganizationMembersEpic.js'
import { UpdateOrganizationMemberEpic } from './UpdateOrganizationMember/UpdateOrganizationMemberEpic.js'
import { UpdateOrganizationEpic } from './UpdateOrganization/UpdateOrganizationEpic.js'
import { GetOrganizationEpic } from './GetOrganization/GetOrganizationEpic.js'
import { UpdateOrganizationLogoEpic } from './UpdateOrganizationLogo/UpdateOrganizationLogoEpic.ts'
import { DeleteOrganizationLogoEpic } from './DeleteOrganizationLogo/DeleteOrganizationLogoEpic.ts'
import { GetRelatedOrganizationsEpic } from './GetRelatedOrganizationsEpic/GetRelatedOrganizationsEpic.js'

export const organizationEpics = combineEpics(
  ListOrganizationsEpic,
  GetOrganizationMembersEpic,
  UpdateOrganizationMemberEpic,
  UpdateOrganizationEpic,
  GetOrganizationEpic,
  UpdateOrganizationLogoEpic,
  DeleteOrganizationLogoEpic,
  GetRelatedOrganizationsEpic,
)
